
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Dropdown from "@/components/Dropdown.vue";
import { getSymbolByValue } from "@/config/data/AwardSymbols";
import { Action, Getter } from "vuex-class";
import IBottleSize from "@/models/IBottleSize";
import IPageCategory from "@/models/IPageCategory";
import IWine from "@/models/IWine";
import AppConfig from "@/config/AppConfig";
import MultiSelect from "@/components/multiselect/MultiSelect.vue";
import i18n from "@/locales";
import { BModal } from "bootstrap-vue";
// @ts-ignore
import VueLazyInput from "vue-lazy-input";
Vue.use(VueLazyInput);

const namespace: string = "page";
const bottleSizeNamespace: string = "bottlesize";
const pageCategoryNamespace: string = "pagecategory";
const wineNamespace: string = "wine";

@Component({
  components: { Dropdown, MultiSelect, BModal }
})
export default class PageWineRight extends Vue {
  public name: string = "PageWineRight";
  private resourceName = "page";
  private awardToSymbol = getSymbolByValue;
  private readonly MAX_ROW_COUNT = 27;
  private selectedForRemovalCategory: IPageCategory | null = null;
  private deleteCategoryMessage: string = "";
  private filteredWines: Array<IWine> = [];
  public newBottleSize1: IBottleSize | null = null;
  public newBottleSize2: IBottleSize | null = null;
  protected newCategoryRow: IPageCategory = {
    id: 0,
    category: "",
    position: 100,
    bottle_size1: this.newBottleSize1,
    bottle_size2: this.newBottleSize2
  };
  public newWineRows: Array<IWine | null> = [];
  protected host = process.env.VUE_APP_BACKEND_HOST;
  protected selectAnotherPriceModalId = "select-another-price-modal";
  protected confirmedBottleSizes: boolean = false;
  protected tempCategory: IPageCategory = {
    id: 0,
    category: "",
    position: 0,
    bottle_size1: null,
    bottle_size2: null
  };
  protected tempBottleSize: any;
  protected tempFiled: string = "";
  protected emptyBottleSize: IBottleSize = {
    id: null,
    size: "***",
    priority_size: 0,
    created_at: null,
    updated_at: null
  };
  protected selectedWines: Array<IWine> = [];
  protected tempIndex: number | null = null;
  protected tempBottleSizeRef: string | null = null;
  protected categoryWineCount: number = 0;

  @Getter("getList", { namespace: bottleSizeNamespace })
  protected bottleSizes?: Array<IBottleSize>;
  @Action("search", { namespace: bottleSizeNamespace })
  protected bottleSizesGetAction: any;
  @Getter("getList", { namespace: pageCategoryNamespace })
  protected pageCategories?: Array<IPageCategory>;
  @Getter("isCreated", { namespace: pageCategoryNamespace })
  protected isPageCategoryCreated?: boolean;
  @Getter("isUpdated", { namespace: pageCategoryNamespace })
  protected isPageCategoryUpdated?: boolean;
  @Getter("isDeleted", { namespace: pageCategoryNamespace })
  protected isPageCategoryDeleted?: boolean;
  @Getter("isSwapped", { namespace: pageCategoryNamespace })
  protected isPageCategorySwapped?: boolean;
  @Action("findByPage", { namespace: pageCategoryNamespace })
  protected pageCategoriesGetAction: any;
  @Action("create", { namespace: pageCategoryNamespace })
  protected pageCategoriesCreateAction: any;
  @Action("update", { namespace: pageCategoryNamespace })
  protected pageCategoriesUpdateAction: any;
  @Action("del", { namespace: pageCategoryNamespace })
  protected pageCategoriesDeleteAction: any;
  @Action("swapPositions", { namespace: pageCategoryNamespace })
  protected pageCategoriesSwapPositionsAction: any;
  @Action("swapWinePositions", { namespace: pageCategoryNamespace })
  protected pageCategoriesWineSwapPositionsAction: any;

  @Action("moveWineToPositionOf", { namespace: pageCategoryNamespace })
  protected moveWineToPositionOfAction: any;

  @Action("swapWineCategory", { namespace: pageCategoryNamespace })
  protected pageCategoriesWineSwapCategoryAction: any;
  @Action("addWine", { namespace: pageCategoryNamespace })
  protected pageCategoriesAddWineAction: any;
  @Action("removeWine", { namespace: pageCategoryNamespace })
  protected pageCategoriesRemoveWineAction: any;
  @Action("removeWines", { namespace: pageCategoryNamespace })
  protected pageCategoriesRemoveWinesAction: any;
  @Getter("getList", { namespace: wineNamespace })
  protected wines?: Array<IWine>;
  @Action("search", { namespace: wineNamespace })
  protected winesGetAction: any;
  @Action("addPrice", { namespace: wineNamespace })
  protected addPriceAction: any;

  @Prop()
  public item: any;

  @Prop({ default: () => {} })
  public saveAction: any;

  @Prop({ required: true })
  protected userId?: number | null;

  @Watch("isPageCategoryCreated")
  protected onPageCategoryCreated(created: boolean) {
    if (created) {
      this.initNewPageCategory();
      this.loadPageCategories();
    }
  }

  @Watch("isPageCategoryUpdated")
  protected onPageCategoryUpdated(updated: boolean): void {
    this.loadPageCategories();
  }

  @Watch("isPageCategoryDeleted")
  protected onPageCategoryDeleted(deleted: boolean): void {
    if (deleted) {
      this.loadPageCategories();
    }
  }

  @Watch("isPageCategorySwapped")
  protected onPageCategoriesSwapped(swapped: boolean): void {
    if (swapped) {
      this.loadPageCategories();
    }
  }

  @Watch("pageCategories")
  protected async onPageCategoriesLoaded(pageCategories: Array<IPageCategory>) {
    if (pageCategories) {
      await this.selectedWinesFilter();
      await this.forceCloseDropdown(this.tempIndex, this.tempBottleSizeRef);
    }
  }

  @Watch("item", { immediate: true, deep: true })
  protected onChangeItem() {
    this.loadPageCategories();
  }

  @Watch("pageCategories")
  protected onPageCategoriesLoad(categories: Array<IPageCategory>): void {
    let rowCount: number = 0;
    this.newWineRows = [];
    for (const category of categories) {
      rowCount++;
      // filter the bottle_sizes
      if (category.wines) {
        for (const wine of category.wines) {
          rowCount++;
          const price1: any = wine.bottle_sizes.find(
            (bottleSize: { bottle_size_id: number | undefined }) =>
              category.bottle_size1 &&
              bottleSize.bottle_size_id == category.bottle_size1.id
          );
          if (price1) {
            wine.price1 = price1.price;
          }
          const price2: any = wine.bottle_sizes.find(
            (bottleSize: { bottle_size_id: number | undefined }) =>
              category.bottle_size2 &&
              bottleSize.bottle_size_id == category.bottle_size2.id
          );
          if (price2) {
            wine.price2 = price2.price;
          }
        }
      }
      // add a add wine row
      const newWineRow: IWine | null = null;
      this.newWineRows.push(newWineRow);
    }
    if (this.item && this.item.footer) {
      rowCount += this.item.footer.split(/\r\n|\r|\n/).length;
    }
    if (rowCount >= this.MAX_ROW_COUNT) {
      this.$bvModal.show("modal-page-row-count-warning");
    }
  }

  protected categoryDragStartHandler(
    $event: DragEvent,
    category: IPageCategory
  ): void {
    const dataTransfer: any = $event.dataTransfer;
    if (!dataTransfer) {
      throw "Data transfer not defined!";
    }
    dataTransfer.setData("category", String(category.id));
  }

  protected categoryDragOverHandler($event: DragEvent): void {
    $event.preventDefault();
  }

  protected categoryDropHandler(
    $event: DragEvent,
    category: IPageCategory
  ): void {
    $event.preventDefault();

    const dataTransfer: any = $event.dataTransfer;
    if (!dataTransfer) {
      throw "Data transfer not defined!";
    }
    const categoryId = category.id;
    if (!categoryId) {
      throw "Missing category id!";
    }

    // drop category into category
    const droppedCategoryId = dataTransfer.getData("category");
    if (droppedCategoryId) {
      this.swapCategoryPositions(
        Number.parseInt(droppedCategoryId),
        categoryId
      );
    }

    // drop wine into category
    const droppedWineId = dataTransfer.getData("wine");
    const droppedWineCategoryId = dataTransfer.getData("wineCategory");
    if (droppedWineId && droppedWineCategoryId) {
      this.swapWineCategory(
        Number.parseInt(droppedWineId),
        Number.parseInt(droppedWineCategoryId),
        categoryId
      );
    }
  }

  protected wineDragStartHandler(
    $event: DragEvent,
    wine: IWine,
    category: IPageCategory
  ): void {
    const dataTransfer: any = $event.dataTransfer;
    if (!dataTransfer) {
      throw "Data transfer not defined!";
    }
    dataTransfer.setData("wineId", wine.id);
    dataTransfer.setData("wineCategoryId", category.id);
  }

  protected wineDragOverHandler($event: DragEvent): void {
    $event.preventDefault();
  }

  protected wineDropHandler(
    $event: DragEvent,
    wine: IWine,
    category: IPageCategory
  ): void {
    $event.preventDefault();
    const dataTransfer: any = $event.dataTransfer;
    if (!dataTransfer) {
      throw "Data transfer not defined!";
    }
    const wineId = wine.id;
    if (!wineId) {
      throw "Missing wine id!";
    }
    const categoryId = category.id;
    if (!categoryId) {
      throw "Missing category id!";
    }
    const droppedWineId = dataTransfer.getData("wineId");
    const droppedCategoryId = dataTransfer.getData("wineCategoryId");
    if (droppedWineId && droppedCategoryId) {
      this.moveWineToPositionOf(
        Number.parseInt(droppedWineId),
        Number.parseInt(droppedCategoryId),
        wineId,
        categoryId
      );
    }
  }

  protected wineDropHandlerOld(
    $event: DragEvent,
    wine: IWine,
    category: IPageCategory
  ): void {
    $event.preventDefault();
    const dataTransfer: any = $event.dataTransfer;
    if (!dataTransfer) {
      throw "Data transfer not defined!";
    }
    const wineId = wine.id;
    if (!wineId) {
      throw "Missing wine id!";
    }
    const categoryId = category.id;
    if (!categoryId) {
      throw "Missing category id!";
    }
    const droppedWineId = dataTransfer.getData("wine");
    const droppedCategoryId = dataTransfer.getData("wineCategory");
    if (droppedWineId && droppedCategoryId) {
      this.swapWinePositions(
        Number.parseInt(droppedWineId),
        wineId,
        Number.parseInt(droppedCategoryId),
        categoryId
      );
    }
  }

  private initNewPageCategory(): void {
    this.newCategoryRow = {
      id: 0,
      category: "",
      page_id: this.item.id,
      bottle_size1: this.newBottleSize1,
      bottle_size2: this.newBottleSize2
    };
  }

  private loadPageCategories(): void {
    this.pageCategoriesGetAction({
      resource: "page-category",
      params: {
        page_id: this.$route.params.id
      }
    });
  }

  protected addCategory(): void {
    this.newCategoryRow.page_id = this.item.id;
    this.pageCategoriesCreateAction({
      resource: "page-category",
      data: this.newCategoryRow,
      descriptionField: "category"
    });
  }

  protected updateCategory(category: IPageCategory): void {
    this.pageCategoriesUpdateAction({
      resource: "page-category",
      data: category,
      id: category.id,
      descriptionField: "category"
    });
  }

  protected swapCategoryPositions(
    categoryId1: number,
    categoryId2: number
  ): void {
    this.pageCategoriesSwapPositionsAction({
      resource: "page-category",
      params: {
        id1: categoryId1,
        id2: categoryId2
      },
      descriptionField: "category"
    });
  }

  protected showRemoveCategoryModal(category: IPageCategory): void {
    this.selectedForRemovalCategory = category;
    this.$bvModal.show("modal-delete-page-category-confirm");
    this.deleteCategoryMessage = String(
      i18n.t("general.question_sure_that_you_want_to_delete_category", {
        category: this.selectedForRemovalCategory.category
      })
    );
  }

  protected removeSelectedCategory(): void {
    this.$bvModal.hide("modal-delete-page-category-confirm");
    if (this.selectedForRemovalCategory) {
      this.removeCategory(this.selectedForRemovalCategory);
    } else {
      throw "No category selected";
    }
  }

  protected removeCategory(category: IPageCategory): void {
    this.newCategoryRow.page_id = this.item.id;
    this.pageCategoriesDeleteAction({
      resource: "page-category",
      resourceName: "category",
      id: category.id,
      descriptionField: category.category
    });
  }

  protected addWine(wine: IWine, category: IPageCategory): void {
    if (!wine) {
      return;
    }
    this.newCategoryRow.page_id = this.item.id;
    this.pageCategoriesAddWineAction({
      resource: "page-category",
      resourceName: "category",
      params: {
        category_id: category.id,
        wine_id: wine.id,
        wine_name: wine.wine
      },
      descriptionField: "category"
    });
  }

  protected removeWine(wine: IWine, category: IPageCategory): void {
    if (!wine) {
      return;
    }
    this.newCategoryRow.page_id = this.item.id;
    this.pageCategoriesRemoveWineAction({
      resource: "page-category",
      resourceName: "category",
      params: {
        category_id: category.id,
        wine_id: wine.id,
        wine_name: wine.wine
      },
      descriptionField: "category"
    });
  }

  protected swapWinePositions(
    wineId1: number,
    wineId2: number,
    categoryId1: number,
    categoryId2: number
  ): void {
    this.pageCategoriesWineSwapPositionsAction({
      resource: "page-category",
      params: {
        wine_id_1: wineId1,
        wine_id_2: wineId2,
        category_id_1: categoryId1,
        category_id_2: categoryId2
      },
      descriptionField: "category"
    });
  }

  protected moveWineToPositionOf(
    wineId1: number,
    categoryId1: number,
    wineId2: number,
    categoryId2: number
  ): void {
    this.moveWineToPositionOfAction({
      resource: "page-category",
      params: {
        wine_id_1: wineId1,
        category_id_1: categoryId1,
        wine_id_2: wineId2,
        category_id_2: categoryId2
      },
      descriptionField: "category"
    });
  }

  protected swapWineCategory(
    wineId1: number,
    categoryId1: number,
    categoryId2: number
  ): void {
    this.pageCategoriesWineSwapCategoryAction({
      resource: "page-category",
      params: {
        wine_id_1: wineId1,
        category_id_1: categoryId1,
        category_id_2: categoryId2
      },
      descriptionField: "category"
    });
  }

  public created() {
    this.bottleSizesGetAction({
      resource: "bottle-size",
      params: {
        currentPerPage: AppConfig.DEFAULT_TABLE_RESULTS_PER_PAGE,
        currentPage: 1
      }
    });
    this.winesGetAction({
      resource: "wine",
      params: {
        currentPerPage: 10000,
        currentPage: 1,
        sort: [
          {
            field: "wine",
            type: "asc"
          }
        ],
        userId: this.userId
      }
    });
    this.loadPageCategories();
  }

  protected save(): void {
    this.saveAction({
      resource: "page",
      resourceName: String(i18n.t("general.page")),
      data: this.item,
      id: this.item.id
    });
  }

  protected filterWines(category: IPageCategory): Array<IWine> {
    if (!this.wines) {
      return [];
    }

    return this.wines.filter((wine: IWine) => {
      for (const selectedWine of this.selectedWines) {
        if (wine.id === selectedWine.id) {
          return false;
        }
      }

      // filtering by bottle size
      if (wine.bottleSizes) {
        return this.filterWine(wine, category, "bottleSizes");
      }
    });
  }

  protected selectedWinesFilter() {
    this.selectedWines = [];
    if (!this.pageCategories) {
      return;
    }
    this.pageCategories.forEach((page: IPageCategory) => {
      if (!page.wines) {
        return;
      }
      page.wines.forEach((item: IWine) => {
        this.selectedWines.push(item);
      });
    });
  }

  protected removeWines(wines: Array<number>, category: IPageCategory): void {
    if (wines.length < 1) {
      return;
    }
    this.newCategoryRow.page_id = this.item.id;
    this.pageCategoriesRemoveWinesAction({
      resource: "page-category",
      resourceName: "category",
      additional: "remove-wines",
      data: {
        wines: wines,
        category_id: category.id
      },
      descriptionField: "category"
    });
  }

  protected confirmBottleSizes(): void {
    this.$bvModal.hide(this.selectAnotherPriceModalId);
    this.confirmedBottleSizes = true;
    this.onSelectBottleSize(
      this.tempBottleSize,
      this.tempCategory,
      this.tempFiled,
      this.tempIndex,
      this.tempBottleSizeRef
    );
  }

  protected filterWine(
    wine: IWine | undefined,
    category: IPageCategory,
    field: string = "bottle_sizes"
  ): boolean {
    if (wine) {
      let bottleSize1 = false;
      let bottleSize2 = false;
      let bottleSize1Empty = false;
      let bottleSize2Empty = false;
      //@ts-ignore
      wine[field].forEach((bottleSize: any) => {
        if (
          category.bottle_size1 &&
          bottleSize.bottle_size_id == category.bottle_size1.id
        ) {
          bottleSize1 = true;
        }
        if (
          category.bottle_size2 &&
          bottleSize.bottle_size_id == category.bottle_size2.id
        ) {
          bottleSize2 = true;
        }
        if (
          category.bottle_size1 &&
          category.bottle_size1.id === this.emptyBottleSize.id
        ) {
          bottleSize1Empty = true;
        }
        if (
          category.bottle_size2 &&
          category.bottle_size2.id === this.emptyBottleSize.id
        ) {
          bottleSize2Empty = true;
        }
      });
      return (
        bottleSize1 ||
        bottleSize2 ||
        (bottleSize1 &&
          category.bottle_size1 &&
          category.bottle_size1.priority_size == 1) ||
        (bottleSize2 &&
          category.bottle_size2 &&
          category.bottle_size2.priority_size == 1) ||
        (bottleSize1Empty && bottleSize2) ||
        (bottleSize2Empty && bottleSize1) ||
        (bottleSize2Empty && bottleSize1Empty)
      );
    }
    return true;
  }

  public async onSelectBottleSize(
    bottleSize: any,
    category: IPageCategory,
    field: string,
    index: number | null,
    bottleSizeRef: string | null
  ): Promise<any> {
    // @ts-ignore
    if (!bottleSize) return;

    if (bottleSize.id === this.emptyBottleSize.id) {
      // @ts-ignore
      category[field] = bottleSize;
      await this.updateCategory(category);
      return;
    }

    let removeWines: Array<number> = [];
    if (
      this.confirmedBottleSizes ||
      !category.bottle_size1 ||
      !category.bottle_size2 ||
      this.selectedWines.length < 1
    ) {
      // @ts-ignore
      category[field] = bottleSize;
      if (category.wines) {
        const existWines = category.wines.filter((wine: IWine) => {
          return this.filterWine(wine, category, "bottle_sizes");
        });

        category.wines.forEach((wine: IWine) => {
          const x = existWines.find((wine2: IWine) => {
            return wine == wine2;
          });
          if (!x) {
            removeWines.push(Number(wine.id));
          }
        });
      }

      await this.removeWines(removeWines, category);
      await this.updateCategory(category);
      this.confirmedBottleSizes = false;
      return;
    }

    this.tempCategory = category;
    this.tempFiled = field;
    this.tempBottleSize = bottleSize;
    this.tempIndex = index;
    this.tempBottleSizeRef = bottleSizeRef;
    this.$bvModal.show(this.selectAnotherPriceModalId);
  }

  public get bottleSizesComputed() {
    if (this.bottleSizes) {
      this.bottleSizes.push(this.emptyBottleSize);
    }
    return this.bottleSizes;
  }

  public get pageCategoriesComputed() {
    return (
      this.pageCategories &&
      this.pageCategories.map((pageCategory: IPageCategory) => {
        if (pageCategory.bottle_size1 == null) {
          pageCategory.bottle_size1 = this.emptyBottleSize;
        }
        if (pageCategory.bottle_size2 == null) {
          pageCategory.bottle_size2 = this.emptyBottleSize;
        }
        return pageCategory;
      })
    );
  }

  public forceCloseDropdown(
    refIndex: number | null,
    bottleSizeRef: string | null
  ) {
    if (refIndex == null || bottleSizeRef == null) return;
    // @ts-ignore
    this.$refs[bottleSizeRef][refIndex].deactivate();
  }
}
